module.exports = __webpack_public_path__ + "static/img/006.0042edc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/006.png
// module id = f+PC
// module chunks = 0